import axios from "@/libs/api.request";
// 获取列表
export const getLog = params => {
  return axios.request({
    url: "/authority/menu/log",
    params,
    method: "get"
  });
};
// 创建列表
export const getLogType = params => {
  return axios.request({
    url: "/common/logType",
    params,
    method: "get"
  });
};
